var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { SpinnerContainer, SpinnerSVG, SpinnerSVGCircle, SpinnerText, } from './styles/spinner.styled';
const getSize = (size) => {
    if (size === 'huge') {
        if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.warn(`DEPRECATION WARNING: Spinner size huge has been renamed to large. Please update this in your implementation.`);
        }
        return 'large';
    }
    return size;
};
/**
 * The Spinner component can be used to render a spinner to wait for data to load
 */
const Spinner = (_a) => {
    var { message, size, inline, class: className } = _a, props = __rest(_a, ["message", "size", "inline", "class"]);
    const spinnerClassNames = classNames('PONCHO-spinner', className, {
        'PONCHO-spinner--inline': inline,
        [`PONCHO-spinner--${size || 'medium'}`]: size,
    });
    return (React.createElement(SpinnerContainer, Object.assign({ className: spinnerClassNames, "$inline": inline }, props),
        React.createElement(SpinnerSVG, { "$size": getSize(size) || 'medium', viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement(SpinnerSVGCircle, { "$position": "background", cx: 10, cy: 10, r: 3 }),
            React.createElement(SpinnerSVGCircle, { "$position": "foreground", fillOpacity: 0.3, cx: 10, cy: 10, r: 3 }),
            React.createElement(SpinnerSVGCircle, { "$position": "background", cx: 20, cy: 5.85, r: 3 }),
            React.createElement(SpinnerSVGCircle, { "$position": "foreground", fillOpacity: 0.4, cx: 20, cy: 5.85, r: 3 }),
            React.createElement(SpinnerSVGCircle, { "$position": "background", cx: 30, cy: 10, r: 3 }),
            React.createElement(SpinnerSVGCircle, { "$position": "foreground", fillOpacity: 0.5, cx: 30, cy: 10, r: 3 }),
            React.createElement(SpinnerSVGCircle, { "$position": "background", cx: 34.15, cy: 20, r: 3 }),
            React.createElement(SpinnerSVGCircle, { "$position": "foreground", fillOpacity: 0.6, cx: 34.15, cy: 20, r: 3 }),
            React.createElement(SpinnerSVGCircle, { "$position": "background", cx: 30, cy: 30, r: 3 }),
            React.createElement(SpinnerSVGCircle, { "$position": "foreground", fillOpacity: 0.7, cx: 30, cy: 30, r: 3 }),
            React.createElement(SpinnerSVGCircle, { "$position": "background", cx: 20, cy: 34.15, r: 3 }),
            React.createElement(SpinnerSVGCircle, { "$position": "foreground", fillOpacity: 0.8, cx: 20, cy: 34.15, r: 3 }),
            React.createElement(SpinnerSVGCircle, { "$position": "background", cx: 10, cy: 30, r: 3 }),
            React.createElement(SpinnerSVGCircle, { "$position": "foreground", fillOpacity: 0.9, cx: 10, cy: 30, r: 3 }),
            React.createElement(SpinnerSVGCircle, { "$position": "background", cx: 5.85, cy: 20, r: 3 }),
            React.createElement(SpinnerSVGCircle, { "$position": "foreground", cx: 5.85, cy: 20, r: 3 })),
        message && React.createElement(SpinnerText, { className: "PONCHO-spinner__message" },
            message,
            "...")));
};
Spinner.defaultProps = {
    class: '',
    size: 'medium',
    message: '',
    inline: false,
};
export default Spinner;
//# sourceMappingURL=Spinner.js.map